/*
var switchImage = function(newSizedImageSrc, newImage, mainImageDomEl) {
    var largestImage = newSizedImageSrc.replace('_1024x1024', '');
    $(mainImageDomEl)
      .attr('src', newSizedImageSrc)
      .parents('a')
      .attr('href', largestImage);

    $(mainImageDomEl)
      .parent()
      .trigger('zoom.destroy')
      .zoom( { url: largestImage } );

  };

  $('.prod_other_img a').click(function(e){
    e.preventDefault();
    var newSizedImageSrc = $(this).attr('href');
    var mainImageDomEl = $('#product-featured-image img')[0];
    switchImage(newSizedImageSrc, null, mainImageDomEl);
  });

*/




(function($) {
 "use strict"

 // Accordion Toggle Items
   var iconOpen = 'fa fa-minus',
        iconClose = 'fa fa-plus';

    $(document).on('show.bs.collapse hide.bs.collapse', '.accordion', function (e) {
        var $target = $(e.target)
          $target.siblings('.accordion-heading')
          .find('em').toggleClass(iconOpen + ' ' + iconClose);
          if(e.type == 'show')
              $target.prev('.accordion-heading').find('.accordion-toggle').addClass('active');
          if(e.type == 'hide')
              $(this).find('.accordion-toggle').not($target).removeClass('active');
    });
    
    $('.textStyle').click(function(){     
        
//        $(this).find('em').toggleClass(iconOpen + ' ' + iconClose);
//        $(this).find('em').toggleClass('backgroundColorToggle');
        
        var otherElements =$(this).parent().siblings();
//        otherElements.removeClass('in');
        
        
        if(otherElements.hasClass('in')){
                 $(this).parent().siblings('.in').removeClass('in');
                 $(this).parent().siblings('.in').attr('aria-expanded','false');
                 $('.smallToggleCircles').removeClass('fa fa-caret-down');
                 $('.smallToggleCircles').addClass('fa fa-caret-right');
                 
        }
            if(!($(this).parent().next().hasClass('in'))){
                
                $(this).parent().siblings('.in').attr('aria-expanded','true');
                $(this).parent().siblings('.in').addClass('in');
                $(this).children('.smallToggleCircles').removeClass('fa fa-caret-right');
                $(this).children('.smallToggleCircles').addClass('fa fa-caret-down');

            }
              
         
      
        
       
    });
    

})(jQuery);

$(document).ready(function() {


  // $('a.togglelink').on('click', function (e) {
  //   e.preventDefault();
  //   var elem = $(this).next('.toggle')
  //   elem.slideToggle('slow');
  // });

  $( "#arrivingSoonDialog" ).dialog({
    //width: 550,
    width: '100%',
    maxWidth: 600,
    height: 400,
    autoOpen: false,
    modal: true,
    fluid: true,
    create: function(event, ui) {
        var widget = $(this).dialog("widget");
        $(".ui-dialog-titlebar-close span", widget).removeClass("ui-icon-closethick").addClass("ui-icon-myCloseButton");
    }
  });

  //Arriving Soon
$( ".arrivingSoonPopup" ).click(function(e) {
	e.preventDefault();

  	$('#arrivingSoonDialog .variantOptions').html("");
  	$('#arrivingSoonDialog .ajax-load').hide();
  	$('#arrivingSoonDialog #notifyRequestResponse').html('');
  	$('#arrivingSoonDialog .notifyProductImage').html('');
  	$(".ui-dialog-titlebar").removeClass('ui-widget-header');
  	var variantString = $(this).data('variants');
  	//console.log(variantString);
    $.each(variantString, function(key,value) {
      if(key != 'end'){
        //$('#arrivingSoonDialog .variantOptions').append(key+' -- '+value);
        var buttonHTML = '<input name="svid" value="'+key+'" type="radio" id="'+key+'" class="notifyVarSelect" /><label class="vSelect" for="'+key+'">'+value+'</label>';
        $('#arrivingSoonDialog .variantOptions').append(buttonHTML);
      }
    });

  	var varImage = $(this).data('image');
  $('#arrivingSoonDialog .notifyProductImage').append('<img style="width:160px;" src="'+varImage+'" />');


  	var notifyEmail = $(this).data('email');
	$('#arrivingSoonDialog .notifyEmail').val(notifyEmail);

  var expectedArrival = $(this).data('expectedarrival');
  $('#arrivingSoonDialog .expectedArrivalDate').text(expectedArrival);

    //$( "#arrivingSoonDialog .variantOptions" ).text( $(this).data( "variants" ) );
    $("#arrivingSoonDialog").dialog("open");
  fluidDialog();
});
  /*
$( "#arrivingSoonDialog" ).dialog({
    //width: 550,
  	width: '100%',
   maxWidth: 600,
    height: 400,
    autoOpen: false,
    modal: true,
  fluid: true,
});
  */
$('#arrivingSoonDialog').on('click', '.vSelect', function() {
   var labelID = $(this).attr('for');
  //$('#'+labelID).trigger('click');
  $('#'+labelID).attr('checked',true);
  $('.vSelect').removeClass("selected");
  $(this).addClass("selected");
  //$( "#notifyRequestSubmit" ).show();
});

$( "#notifyRequestSubmit" ).click(function(e) {
  e.preventDefault();
  $('#arrivingSoonDialog #notifyRequestResponse').html('');

  if ($('input[name="svid"]:checked').length) {
           // at least one of the radio buttons was checked
          	var formData = $("#notifyRequest").serialize();
    		//console.log(formData);
    		$(this).hide();
    		$('#arrivingSoonDialog .ajax-load').show();
      }
      else {
           // no radio button was checked
        $('#arrivingSoonDialog #notifyRequestResponse').html('<span style="color:red;">Please choose a size...</span>');
        return false;
      }

  $.ajax({
        url : "https://features.shopimpressions.com/notify/comingsoon",
        cache : false,
        type : "POST",
        dataType : 'json',
        data : formData,
        beforeSend : function() {
            //console.log('notifyRequestSubmit beforeSend');
        },
        success : function(data) {
            $('#arrivingSoonDialog .ajax-load').hide();
            //console.log('notifyRequestSubmit success');
          	//console.log(data);

            if(!data.success){
                $('#notifyRequestResponse').html('<p style="color:red;font-weight:bold;">'+data.response+'</p>');
                $("#notifyRequestSubmit").show();
            }
            if(data.success){
                $('#notifyRequestResponse').html('<p style="color:green;font-weight:bold;">'+data.response+'</p>');
            }

        },
        complete : function() {
            console.log('notifyRequestSubmit complete');
        },
        error : function(xhr, status, error) {
            console.error('notifyRequestSubmit: ' + error);
            console.error(xhr);
            console.error('notifyRequestSubmit txerror: ' + status);
        }
    });

});

  // catch dialog if opened within a viewport smaller than the dialog width
// $(document).on("dialogopen", ".ui-dialog", function (event, ui) {
//     fluidDialog();
// });

function fluidDialog() {
    var $visible = $(".ui-dialog:visible");
    // each open dialog
    $visible.each(function () {
        var $this = $(this);
        var dialog = $this.find(".ui-dialog-content").data("ui-dialog");
        // if fluid option == true
        if (dialog.options.fluid) {
            var wWidth = $(window).width();
            // check window width against dialog width
            if (wWidth < (parseInt(dialog.options.maxWidth) + 50))  {
                // keep dialog from filling entire screen
                $this.css("max-width", "90%");
            } else {
                // fix maxWidth bug
                $this.css("max-width", dialog.options.maxWidth + "px");
            }
            //reposition dialog
            dialog.option("position", dialog.options.position);
        }
    });

}


 });

// $(document).ready(function() {

//     $('ul.nav li.dropdown').hover(function() {
//       $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeIn(500);
//     }, function() {
//       $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeOut(500);
//     });

// });



    


// function addToCart() {

// //$('#product-add').attr('value','Item Added');
// //$('#product-add').addClass('addCartBt', function (){
// //    $('.megamenuCart').toggle(400);
// //    $('.megamenuCart').addClass('cartDdropdown');
// //
//     $('.modal').removeClass('hidden').addClass('open');;
//     $('.modal--overlay').removeClass('hidden').addClass('open');;
// //
// //});


// /*
//     $('.megamenuCart').slideDown(750);
//     $('.megamenuCart').addClass('cartDdropdown');
// */

// };


//Count down timer for bar at top of home page
// $(document).ready(function(){
//   $('#clock').countdown('2017/03/12 24:00:00', function(event) {
//   	//$(this).html(event.strftime('%D days %H:%M:%S'));
//           $(this).html(event.strftime('%H:%M:%S'));
//   });
// });
